import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"

// IngestButton di pages/TrovaBando.js (31a5bd1): «Leggi gli allegati ufficiali» avvia l'ingestione dei PDF del bando
// (POST /api/grants/:id/ingest con la pagina ufficiale) e legge ingest-status ogni 4 s, al massimo 30 volte. Fatto:
// l'esito al posto del pulsante; errore o troppo lungo: il pulsante torna disponibile con un toast. Solo per
// l'amministratore della piattaforma (la vista lo mostra solo a lui e l'endpoint lo richiede).
export default class extends Controller {
  static targets = ["bottone", "attesa", "pronto", "fatto", "esito"]
  static values = { id: String, url: String, intervallo: { type: Number, default: 4000 } }

  disconnect() {
    clearInterval(this.timer)
  }

  async avvia() {
    if (!this.urlValue) { window.toast?.error("Nessuna fonte ufficiale disponibile per questo bando"); return }
    this.stato("running")
    const id = encodeURIComponent(this.idValue)
    try {
      await apiJson(`/api/grants/${id}/ingest`, { method: "POST", body: { page_url: this.urlValue } })
      let tries = 0
      clearInterval(this.timer)
      this.timer = setInterval(async () => {
        tries += 1
        let data
        try { data = await apiJson(`/api/grants/${id}/ingest-status`) } catch { return }
        if (data.status === "done") {
          clearInterval(this.timer); this.stato("done", data.result)
          window.toast?.success(data.result?.proposte?.length ? "PDF letti: le proposte sono nella coda di revisione" : "PDF letti: nessuna differenza dai dati del bando")
        } else if (data.status === "error") {
          clearInterval(this.timer); this.stato("error")
          window.toast?.error(data.result?.detail || "Ingestione non riuscita")
        } else if (tries >= 30) {
          clearInterval(this.timer); this.stato("idle"); window.toast?.error("Ingestione troppo lunga, riprova")
        }
      }, this.intervalloValue)
    } catch (e) {
      this.stato("idle")
      window.toast?.error(formatApiErrorDetail(e.detail) || "Ingestione non riuscita")
    }
  }

  stato(s, result = null) {
    const fatto = s === "done" && result
    this.fattoTarget.hidden = !fatto
    this.bottoneTarget.hidden = !!fatto
    if (fatto) {
      const n = result.proposte?.length
      // un solo testo, come il nodo di testo dell'originale nel riquadro flex
      this.esitoTarget.textContent = `PDF letti, nessun dato cambiato — ${n ? `proposte nella coda di revisione (${n} campi)` : "nessuna differenza dai dati del bando"}`
    }
    this.bottoneTarget.disabled = s === "running" || !this.urlValue
    this.attesaTarget.hidden = s !== "running"
    this.prontoTarget.hidden = s === "running"
  }
}
